// https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#example
// https://enhancedecommerce.appspot.com

var gaCustomerId = $('.ga_customerId').val();
var customerId = "";
if(gaCustomerId !== ""){
  customerId = gaCustomerId
}
else{
  customerId = "";
}

// ------ code to get ga id starts here -----
var cookiesObj = {};
var gaCookiesString = document.cookie;
var cookiesValuesArray = gaCookiesString.split(";");
for(var i=0;i<cookiesValuesArray.length;i++){
  var cookieValue = cookiesValuesArray[i];
  var valuesArray = cookieValue.split("=");
  var key = (valuesArray[0]).trim();
  var value = valuesArray[1];
  cookiesObj[key] = value;
}
var gaId = "";
var responseGaId = cookiesObj._ga;
var isGaIdExists = cookiesObj.hasOwnProperty("_ga");
if(isGaIdExists === true){
  var gaIdArray = responseGaId.split(".");
  var gaIdArrayLength = gaIdArray.length;
  gaId = gaIdArray[gaIdArrayLength-2]+"."+gaIdArray[gaIdArrayLength-1];
}

// ---------------- ga id code ends here ----

var cidAndGaid = customerId+"-"+gaId;

function setGaId(){
  ga('set','dimension1', customerId);
  ga('set','dimension2', gaId);
  ga('set','dimension3', cidAndGaid);
  ga('send', 'pageview');
}


function gtm_availabilityCheck(detailObj){
  console.log(detailObj);

  var enteredPincode = detailObj.pincode;
  console.log(enteredPincode);
  
 ga('set','dimension9', enteredPincode);
  
  dataLayer.push({ 
    'event': 'pincodeAvailabilityCheck', 
    'customCode': enteredPincode,
    'eventAction': 'Check', 
    'eventCategory': 'Pincode'
  });
  
  posthog.capture('pincodeCheck', {pincode: enteredPincode, status: detailObj.status, gaId: gaId});
  
}

// Measuring  Product Impression
function ga_addImpression(productObject,listName){
//   if(!($.isEmptyObject(productObject))){
//     var id = productObject.productId;
//     var name = productObject.productTitle;
//     var category = productObject.productType;
//     var brand = productObject.productBrand;
//     var sku = productObject.productSku;
    
//     ga('ec:addImpression', {
//         'id': sku,
//         'name': name,
//         'category': category,
//         'brand': brand,
//         'variant': id,
//         'list': listName
// //         'dimension1':customerId,
// //         'dimension2':gaId,
// //         'dimension3':cidAndGaid
//       });
//     ga('send', 'pageview'
// //        ,{
// //       'dimension1':customerId,
// //       'dimension2':gaId,
// //       'dimension3':cidAndGaid
// //     }
//       ); 
//   }
}

// on registred customer
function ga_onRegister(){
  // Register. Placement: This code is to be placed when someone clicks on Register. 07.02.2019 
	dataLayer.push({ 
      'event': 'Registration', 
      'eventCategory': 'Registration', 
      'eventAction': 'Submit', 
      'eventLabel':'Success'
    }); 

  localStorage.removeItem("ga_registredEmail");
}


// function is to move to wishlist from cart
function ga_cartMoveToWishlist(productObj){ 
  // AddToWishlist Placement: This code is to be placed when someone adds a product to wishlist(OnClick). 07.02.2019
  let sku = "";
  let sellingPrice = "";
  if(productObj !== undefined && (!($.isEmptyObject(productObj)))){
    
    if(productObj.sku !== undefined ){
      sku = productObj.sku;
    }
    if(productObj.unitPrice !== undefined){
      sellingPrice = productObj.unitPrice;
    }
  }
	dataLayer.push({ 
      'event': 'AddToWishlist', 
      'productId': sku, 
      'currency': 'INR', 
      'productPrice': sellingPrice 
    }); 
  getcount(customerId);
}

// functon to move to wishlist from product and collection page
function ga_moveToWishlist(productObj){
  // AddToWishlist Placement: This code is to be placed when someone adds a product to wishlist(OnClick). 07.02.2019
  if(productObj !== undefined && (!($.isEmptyObject(productObj)))){
    var sku = productObj.productSku;
    var price = productObj.sellingPrice;
    
    dataLayer.push({ 
      'event': 'AddToWishlist', 
      'productId': sku, 
      'currency': 'INR', 
      'productPrice': price 
    }); 
  }
  getcount(customerId);
}


$(document).on('click','.slideShow, .homeBlock4',function(){
  let altText = $(this).attr('alt');
  ga_bannerClick(altText);
});

// when user click on the home page banner
function ga_bannerClick(imgaeAltText){
  // BannerClick. Placement: This code is to be placed when someone clicks on the Banners (OnClick). 07.02.2019
  let bannerAltText = "";
  if(imgaeAltText !== undefined){
    bannerAltText = imgaeAltText;
  }
  dataLayer.push({ 
    'event': 'eventsToSend', 
    'eventAction': 'BannerClick', 
    'eventCategory': 'ecommerce', 
    'eventLabel': bannerAltText, 
  }); 

}

// when user click on chat button
// $(window).on('classChange','div#fc_frame',function(){
//   let chatClass = $(this).attr('class');
//   console.log(chatClass);
// });
// $(document).ready(function() {
//   $(document).click(function(){
//     let isGtmRequestSent = false;
//     let iframeHeight =  $('#fc_frame').height();
//     if(iframeHeight > 100 && isGtmRequestSent === false){
//       let chatClass = $('#fc_frame').attr('class');
//       let isChartOpen = chatClass.search('fc-open');
//       if(isChartOpen !== -1){
//         isGtmRequestSent = true;
//         ga_chatClicked();
//         $(document).trigger('click');
//       }
//       else{
//         $(document).trigger('click');
//         isGtmRequestSent = false;
//       }
//     }
//     else{
//       isGtmRequestSent = false;
//       $(document).trigger('click');
//     }
//   console.log(q);
// });
// });
// $(window).on('click','#fc_frame',function(){
//   console.log("clicked on fc frame");
//   let a = $(this).attr('class');
//   console.log(a);
//   ga_chatClicked();
// });

// when user click on chat button
function ga_chatClicked(){
// Start Chat. Placement: This code is to be placed on When the user clicks on start chat option(OnClick). 07.02.2019
  let pageUrl = window.location.href;
	dataLayer.push({ 
	'event': 'eventsToSend', 
    'eventAction': 'StartChat',
    'eventCategory': 'StartChatClick',
    'eventLabel': pageUrl, //dynamic 
}); 
}

// Measuring a Product Click
function ga_productClick(productObject,listName){
  	var id = productObject.productId;
    var name = productObject.productTitle;
    var category = productObject.productType;
    var brand = productObject.productBrand;
    var sku = productObject.productSku;
  
  ga('ec:addProduct', {
    'id': sku,
    'name': name,
    'category': category,
    'brand': brand,
    'variant': id,
    'list': listName
  });
  ga('ec:setAction', 'click', {list: listName});

  // Send click with an event, then send user to product page.
  ga('send', 'event', 'Product', 'click', listName);
  
  
  // BannerClick. Placement: This code is to be placed when someone clicks on the Banners (OnClick). -Done
	dataLayer.push({ 
		'event': 'eventsToSend', 
		'eventAction': 'BannerClick', 
        'eventCategory': 'ecommerce', 
        'eventLabel': name 
    }); 

}


// Measuring a Product Details View
function ga_productDetail(productObject){
	var id = productObject.productId;
    var name = productObject.productTitle;
    var category = productObject.productType;
    var brand = productObject.productBrand;
    var sku = productObject.productSku;
    var price = productObject.sellingPrice;
  
    ga('ec:addProduct', {
      'id': sku,
      'name': name,
      'category': category,
      'brand': brand,
      'variant': id
    });

    ga('ec:setAction', 'detail');

  ga('send', 'pageview');
  
  // PDP Load.Placement: This code is to be placed on the product description page(OnLoad). 07.02.2019
 dataLayer.push({ 'event': 'PDP', 'productId': sku, 'currency': 'INR', 'productPrice':price}); 

}

// this is for when user clickes on add to cart
// Called when a product is added to a shopping cart.
function ga_addToCart(productObject,listName){
    var id = productObject.productId;
    var name = productObject.productTitle;
    var sku = productObject.productSku;
    var category = productObject.productType;
    var price = productObject.sellingPrice;
    var quantity = "1";
    var brand = productObject.productBrand;
  
  let updatedListName = (listName.split(" ").join("_")).toUpperCase();
  if (updatedListName === "COLLECTION_RESULTS") {
    price = getSellingPrice(id);
  }

    ga('ec:addProduct', {
      'id': sku,
      'name': name,
      'category': category,
      'brand': brand,
      'variant': id,
      'price':price,
      'quantity': "1",
      'list': listName
    });
    ga('ec:setAction', 'add');
    ga('send', 'event', 'Cart', 'click', 'add to cart',{
      'list':listName
    });
  
  
  // AddToCart .Placement: This code is to be placed when someone adds a product to cart(OnClick). 07.02.2019
  dataLayer.push({ 'event': 'AddToCart', 'productId': sku, 'currency': 'INR', 'productPrice':price});
}

// when users changes the delivery address
function ga_selectedDeliveryAddress(){
  // Delivery Address Success. Placement: This code is to be placed when the user selects the delivery address(OnClick). 07.02.2019
    dataLayer.push({ 
    	'event': 'eventsToSend', 
      	'eventAction': 'DeliveryAddressSelect', 
      	'eventCategory': 'ecommerce', 
      	'eventLabel': 'Success', 
    }); 
}


// user deletes lineItem from cart
// Called when a product is removed from a shopping cart.
function ga_deleteLineItem(lineItemObj){
  if(!($.isEmptyObject(lineItemObj))){
      var productId = "";
      var title = "";
      var productType = "";
      var vendor = "";
      var sku = "";
      var price = "";
      var quantity = "";
      if(lineItemObj.productId !== null){
        productId = lineItemObj.productId;
      }
      if(lineItemObj.title !== null){
        title = lineItemObj.title;
      }
      if(lineItemObj.productType !== null){
        productType = lineItemObj.productType;
      }
      if(lineItemObj.vendor !== null){
        vendor = lineItemObj.vendor;
      }
      if(lineItemObj.sku !== null){
        sku = lineItemObj.sku;
      }
      if(lineItemObj.unitPrice !== null){
        price = lineItemObj.unitPrice;
      }
      if(lineItemObj.quantity !== null){
        quantity = lineItemObj.customerEnteredQuantity;
      }
    
    ga('ec:addProduct', {
      'id': sku,
      'name': title,
      'category': productType,
      'brand': vendor,
      'variant':  productId,
      'price': price,
      'quantity': quantity
    });
    ga('ec:setAction', 'remove');
    ga('send', 'event', 'Cart', 'click', 'removeFromCart'
      );
  }
}

// on quantity update in the cart
function ga_quantityUpdate(productObject){
  var id = productObject.productId;
  var name = productObject.title;
  var sku = productObject.sku;
  var category = productObject.productType;
  var price = (productObject.unitPrice).toString();
  var quantity = productObject.customerEnteredQuantity;
  var brand = productObject.vendor;
  
  ga('ec:addProduct', {
      'id': sku,
      'name': name,
      'category': category,
      'brand': brand,
      'variant': id,
      'price':price,
      'quantity': quantity
    });
    ga('ec:setAction', 'add');
  ga('send', 'event', 'Cart', 'click', 'add to cart'
    );
}

// Measuring a Transaction
// after order is created
function ga_purchase(data,usedCoupon){
  var orderObj = data.order;
  var orderNumber = orderObj.order_number;
  var revenue = orderObj.total_price;
  var tax = orderObj.total_tax;
  var shippingObj = orderObj.shipping_lines[0];
  var shippingPrice = shippingObj.price
  
  var orderLineItemsArray = orderObj.line_items;
  var lineItemsArrayLength = orderLineItemsArray.length;
  var i;
  
  let productsArray = [];
  for(i=0;i<lineItemsArrayLength;i++){
    var lineItemObj = orderLineItemsArray[i];
    var id = lineItemObj.id;
    var name = lineItemObj.name;
    var brand = lineItemObj.vendor;
    var price = lineItemObj.price;
    var quantity = lineItemObj.quantity;
    var sku = lineItemObj.sku;
    
    ga('ec:addProduct', {
      'id': sku,
      'name': name,
      'brand': brand,
      'variant':  id,
      'price': price,
      'quantity': quantity
    });
    
    let productLineItemObj = {};
    productLineItemObj["name"] = name;
    productLineItemObj["id"] = sku;
    productLineItemObj["price"] = price;
    productLineItemObj["quantity"] = parseInt(quantity);
    productsArray.push(productLineItemObj);
  }
  
//   transaction details
  ga('ec:setAction', 'purchase', {
      'id': "#"+orderNumber,
      'affiliation': 'Website',
      'revenue': revenue,
      'tax': tax,
      'shipping': shippingPrice,
      'coupon': usedCoupon
	});
  
  ga('send', 'event', 'Order', 'Complete', "#"+orderNumber);

  ga('send', 'pageview'); 
  // Purchase. Placement: This code is to be placed when someone clicks on the Place order button and completes the transaction. 07.02.2019 
//     dataLayer.push({ 
//     'event':'transactionComplete', 
//     'ecommerce': { 
//     'currencyCode':'INR', 
//       'purchase': { 
//     	'actionField': { 
//     		'id': "#"+orderNumber, 
//             // Transaction ID. Required for purchases and refunds. 
//             'affiliation': 'Online Store',
//             'revenue': revenue,
//              // Total transaction value (incl. tax and shipping) 
//             'tax':tax,
//             'shipping': shippingPrice, 
//           	'coupon': usedCoupon 
//             }, 
//         	'products': productsArray
//       	} 
//      } 
//     });
}

function gtm_purchase(data,usedCoupon){
  var orderObj = data.order;
  var orderNumber = orderObj.order_number;
  var revenue = orderObj.total_price;
  var tax = orderObj.total_tax;
  var shippingObj = orderObj.shipping_lines[0];
  var shippingPrice = shippingObj.price
  
  var orderLineItemsArray = orderObj.line_items;
  var lineItemsArrayLength = orderLineItemsArray.length;
  var i;
  let productsArray = [];
  for(i=0;i<lineItemsArrayLength;i++){
    var lineItemObj = orderLineItemsArray[i];
    var id = lineItemObj.id;
    var name = lineItemObj.name;
    var brand = lineItemObj.vendor;
    var price = lineItemObj.price;
    var quantity = lineItemObj.quantity;
    var sku = lineItemObj.sku;
    
    let productLineItemObj = {};
    productLineItemObj["name"] = name;
    productLineItemObj["id"] = sku;
    productLineItemObj["price"] = price;
    productLineItemObj["quantity"] = parseInt(quantity);
    productsArray.push(productLineItemObj);
  }
  
  // Purchase. Placement: This code is to be placed when someone clicks on the Place order button and completes the transaction. 07.02.2019 
    dataLayer.push({ 
    'event':'transactionComplete', 
    'ecommerce': { 
    'currencyCode':'INR', 
      'purchase': { 
    	'actionField': { 
    		'id': "#"+orderNumber, 
            // Transaction ID. Required for purchases and refunds. 
            'affiliation': 'Online Store',
            'revenue': revenue,
             // Total transaction value (incl. tax and shipping) 
            'tax':tax,
            'shipping': shippingPrice, 
          	'coupon': usedCoupon 
            }, 
        	'products': productsArray
      	} 
     } 
    });
}

// ------ Checkout Funnel --------
// user click on cart button i.e user comes to cart
// this is step 1 for ga
// when cart loads ga_step1 
function ga_step1_onCartLoads(productDetailArray){
  var productDetailArrayLength = productDetailArray.length;
  var i;
  let skuArray = [];
  let priceArray = [];
  for(i=0;i<productDetailArrayLength;i++){
    var lineItemObj = productDetailArray[i];
    var id = lineItemObj.productId;
  	var name = lineItemObj.title;
  	var sku = lineItemObj.sku;
  	var category = lineItemObj.productType;
  	var price = (lineItemObj.unitPrice).toString();
  	var quantity = lineItemObj.customerEnteredQuantity;
  	var brand = lineItemObj.vendor;
    
    skuArray.push(sku);
    priceArray.push(price);
    
    ga('ec:addProduct', {
      'id': sku,
      'name': name,
      'category': category,
      'brand': brand,
      'variant': id,
      'price': price,
      'quantity': quantity
    });
  }
  
  ga('ec:setAction','checkout',{
    'step': 1
  });
  ga('send', 'pageview');
  
  // CheckOut. Placement: This code is to place on the checkout page (OnPageLoad). 07.02.2019
 dataLayer.push({ 
   'event': 'checkout', 
   'productId': skuArray, 
   'currency': 'INR', 
   'productPrice':priceArray 
 }); 
  
}

// user click on cart checkout button
//  this is step-2 for ga
function ga_step2_onClickOfCheckoutBtn(){
    ga('ec:setAction','checkout', {
         'step': 2
     });
  ga('send', 'pageview');
    
}

// user clicks on address page proceed button
function ga_step3_onClickOfProceedBtn(){
    ga('ec:setAction','checkout', {
         'step': 3
     });
  	ga('send', 'pageview');
  
  
  // Proceed To Payment. Placement: This code is to be placed on when payment selection page load(OnLoad). 07.02.2019
    	dataLayer.push({ 
		'event': 'eventsToSend', 
        'eventAction': 'ProceedToPay', 
        'eventCategory': 'ecommerce', 
        'eventLabel': 'Success'
	}); 
 
}

// when user click on place order button in 
function ga_step4_OnClickPlaceOrder(){
    ga('ec:setAction','checkout', {
         'step': 4
     });
    ga('send', 'pageview');
}




//  ----------------- get selling price -------------

function getSellingPrice(pid) {
  if (collectionPriceResult !== undefined && collectionPriceResult !== null &&
      collectionPriceResult.length > 0) {
    for (let variantObj of collectionPriceResult){
      if (variantObj !== undefined && Object.keys(variantObj).length >0) {
        console.log(variantObj.product_id === pid);
        if (variantObj.product_id === pid) {
          if (variantObj.is_variant_in_sale ) {
            return (variantObj.variant_sale_price);
          } else {
            return variantObj.price;
          }
        }
      }
    }
  }
};
